export default {
  CLASSIC_PROJECTS: 'Classic Projects',
  BUNDLE_PROJECTS: 'Bundle Projects',
  BONUS_PROJECTS: 'Bonus Projects',
  QA_PROJECTS: 'QA Projects',
  LL_PROJECTS: 'LL Projects',
  RATING_PROJECTS: 'Rating Projects',
};
